import { convertCreditsFromServerToClient } from "../../common/datastructures/Credits";
import { GameData } from "./gamestate/gameData";
import { PayTableBuilder } from "./PaytableInGame";

export function createOptionPages(activeGameData: GameData) {
  let optionPageHead: Array<string> = [];
  let optionPageBody: Array<any> = [];
  let optionPageData = [optionPageHead, optionPageBody];
  //define the  header per page
  optionPageHead[0] = activeGameData.gameTextGeneral.optp1head;
  optionPageHead[1] = activeGameData.gameTextGeneral.optp1head;
  //---winlines
  optionPageHead[2] = activeGameData.gameTextGeneral.WINLINES;
  //--
  optionPageHead[3] = activeGameData.gameTextGeneral.Paytable;
  optionPageHead[4] = activeGameData.gameText.optp4head;
  optionPageHead[5] = activeGameData.gameTextGeneral.optp5head;
  optionPageHead[6] = activeGameData.gameTextGeneral.optp6head;
  optionPageHead[7] = activeGameData.gameTextGeneral.optp8head;

  //-define the body contents per page
  let autoplayTiteltext = activeGameData.gameTextGeneral.AUTOPLAY.toLocaleUpperCase();
  let autoplayBodytext = activeGameData.gameTextGeneral.AUTOPLAY_DESCRIPTION;
  let replayTiteltext = activeGameData.gameTextGeneral.REPLAY.toLocaleUpperCase();
  let replayBodytext = activeGameData.gameTextGeneral.REPLAY_DESCRIPTION;

  //-check if autoplay is enabled or not to add in game text;
  let concatText = "\n\n" + replayTiteltext + "\n" + replayBodytext;
  if (activeGameData.commonConfigData.autoplayEnabled) {
    concatText =
      "\n\n" +
      autoplayTiteltext +
      "\n" +
      autoplayBodytext +
      "\n\n" +
      replayTiteltext +
      "\n" +
      replayBodytext;
  }
  //-define the body contents per page
  optionPageBody[0] = activeGameData.gameText.optp1msg + concatText;
  let lowestStake =
    convertCreditsFromServerToClient(
      activeGameData.loginResponse.gameSettings.stakes[0]
    ).toFixed(2) + activeGameData.currency;
  let highestStake =
    convertCreditsFromServerToClient(
      activeGameData.loginResponse.gameSettings.stakes[
        activeGameData.loginResponse.gameSettings.stakes.length - 1
      ]
    ).toFixed(2) + activeGameData.currency;
  let miseMinMaxText =
    activeGameData.gameTextGeneral.MinStake +
    ": " +
    lowestStake +
    " \n " +
    activeGameData.gameTextGeneral.MaxStake +
    ": " +
    highestStake;
  optionPageBody[1] =
    activeGameData.gameText.optp2msg + "\n\n" + miseMinMaxText; //----need image winlines
  // optionPageBody[1] = activeGameData.gameText.optp2msg;//----need image winlines
  let PaytableContainer = new PIXI.Container();
  activeGameData.paytable = new PayTableBuilder(
    PaytableContainer,
    activeGameData
  );
  activeGameData.paytable.updateAllPaytable();

  // activeGameData.paytable.setPositionY(activeGameData.paytable.getPosition()[1]-150);

  // // activeGameData.paytable.setPosition([0,-150]);
  // if(activeGameData.isMobile==false)
  // {

  //     // activeGameData.paytable.setPosition([0,-75]);
  //     // activeGameData.paytable.getParent().scale.set(.3);
  // }

  optionPageBody[2] = "";
  optionPageBody[3] = PaytableContainer;
  // activeGameData.gameTextGeneral.optp1head;//-----paytable--interactive
  optionPageBody[4] = activeGameData.gameText.optp4msg; //----need image firespin
  let jackpotRTP = activeGameData.jackPotGameInstantiated
    ? activeGameData.gameTextGeneral.JACKPOT_RTP_ADD
    : "";
  let RTPText =
    activeGameData.gameText.RTP +
    ": \n" +
    activeGameData.gameText.RTPDescription +
    jackpotRTP;
  optionPageBody[5] = activeGameData.gameText.optp5msg + "\n\n\n " + RTPText; //--game limit
  optionPageBody[6] = activeGameData.gameTextGeneral.GAMBLETEXT;
  optionPageBody[7] = activeGameData.gameTextGeneral.optp8msg;

  //Add the  head and body  tp the page
  for (let i = 0; i < 8; i++) {
    let head: any = optionPageData[0][i];
    let body: any = optionPageData[1][i];
    activeGameData.gameOption.setPages(i, head, body);
  }

  let centerX = activeGameData.size[0] / 2;

  //Add extra images per page
  if (activeGameData.isMobile) {
    activeGameData.gameOption.addImageToPage(
      2,
      new PIXI.Sprite(PIXI.Texture.fromFrame("winLinesDisplay.png")),
      [centerX, 100],
      1,
      1.5,
      0.05
    );
  } else {
    activeGameData.gameOption.addImageToPage(
      2,
      new PIXI.Sprite(PIXI.Texture.fromFrame("winLinesDisplay.png")),
      [centerX, 20],
      1.2,
      2
    );
  }
  activeGameData.gameOption.addImageToPage(
    6,
    new PIXI.Sprite(PIXI.Texture.fromFrame("gamble.png")),
    [centerX, 150],
    1,
    2
  );
  activeGameData.gameOption.setActivePage("goal"); //makes  default page to 0 and also disable buttons

  //assign the function that can chck and add  the jackpotText RTP if available  and call it when jackpot updates
  activeGameData.updateJackpotRtpInfo = (): void => {
    updateRTPTextWithJackpot(activeGameData);
  };
}

function updateRTPTextWithJackpot(activeGameData: GameData) {
  let jackpotRTP = activeGameData.jackPotGameInstantiated
    ? activeGameData.gameTextGeneral.JACKPOT_RTP_ADD
    : "";
  let RTPText =
    activeGameData.gameText.RTP +
    ": \n" +
    activeGameData.gameText.RTPDescription +
    jackpotRTP;
  let newText = activeGameData.gameText.optp5msg + "\n\n\n " + RTPText; //--game limit
  //update text;
  activeGameData.gameOption.getPages()[5].body.text = newText; //--game limit
}
